var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-accordion-container" },
    [
      _c("accordion", {
        staticClass: "blue",
        attrs: { items: _vm.block.market_categories },
        scopedSlots: _vm._u([
          {
            key: "accordion-selector-title",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("span", {
                  domProps: { innerHTML: _vm._s(item.market_category_name) }
                })
              ]
            }
          },
          {
            key: "accordion-item-header-title",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("div", {
                  staticClass: "title",
                  domProps: { innerHTML: _vm._s(item.market_category_name) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "expanded-title" }, [
                  item.market_category_button.title != null
                    ? _c(
                        "a",
                        {
                          staticClass: "btn",
                          attrs: {
                            href: item.market_category_button.url,
                            target: item.market_category_button.target
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                item.market_category_button.title
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-chevron-right" })
                        ]
                      )
                    : _c("div", {
                        staticClass: "title",
                        domProps: {
                          innerHTML: _vm._s(item.market_category_name)
                        }
                      })
                ])
              ]
            }
          },
          {
            key: "accordion-item-content",
            fn: function(ref) {
              var item = ref.item
              return _vm._l(item.subcategory, function(subMarket, index) {
                return _c("div", { key: index, staticClass: "market" }, [
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "div",
                        {
                          staticClass: "primary",
                          style:
                            "background-image: url(" +
                            subMarket.primary_image.url +
                            ");"
                        },
                        [
                          _c("h2", {
                            staticClass: "title",
                            domProps: {
                              innerHTML: _vm._s(subMarket.subcategory_name)
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "secondary bg-white",
                          class: {
                            "with-case-study":
                              subMarket.show_related_case_studies
                          }
                        },
                        [
                          _c("div", { staticClass: "row top" }, [
                            _c("div", { staticClass: "content" }, [
                              _c("div", {
                                staticClass: "top-title",
                                domProps: {
                                  innerHTML: _vm._s(subMarket.content.top_title)
                                }
                              }),
                              _vm._v(" "),
                              _c("h2", {
                                staticClass: "title",
                                domProps: {
                                  innerHTML: _vm._s(subMarket.content.title)
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "copy",
                                domProps: {
                                  innerHTML: _vm._s(subMarket.content.copy)
                                }
                              }),
                              _vm._v(" "),
                              subMarket.content.button
                                ? _c("a", {
                                    staticClass: "btn hover-button bright-blue",
                                    attrs: {
                                      href: subMarket.content.button.url,
                                      target: subMarket.content.button.target
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        subMarket.content.button.title
                                      )
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          subMarket.show_related_case_studies
                            ? _c("div", { staticClass: "row case-study-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "carousel-container" },
                                  [
                                    _c(
                                      "slick-carousel",
                                      {
                                        staticClass: "case-study-carousel",
                                        attrs: {
                                          options: _vm.getCaseStudyCarouselOptions()
                                        }
                                      },
                                      _vm._l(subMarket.case_studies, function(
                                        caseStudy,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "case-study"
                                          },
                                          [
                                            _c("div", { staticClass: "flex" }, [
                                              _c(
                                                "div",
                                                { staticClass: "image" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        caseStudy.acf_fields
                                                          .feature_settings
                                                          .primary_image.url
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "content bg-light-gray"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "top-title"
                                                    },
                                                    [_vm._v("Case Study")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("h2", {
                                                    staticClass: "title",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        caseStudy.post_title
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "button-container"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "hover-button orange",
                                                          attrs: {
                                                            href:
                                                              caseStudy.permalink
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Continue reading"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "divider" })
                  ])
                ])
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }